import axiosInstanceNew from "lib/axiosinstanceNew";

const Shortlistedtutors = class {
    constructor() {
        this.baseUrl = "enquiry/shortlisted_tutors";
}


async addshortlist(data=[]) {

    return (
      await (axiosInstanceNew.post(`${this.baseUrl}`,data))
    )
  }
  async shortlistAll(id) {
   
    return (
      await (axiosInstanceNew.get(`${this.baseUrl}?enquiry_id=${id}`))
    )
  }
  async detail(id,iid) {
   
    return (
      await (axiosInstanceNew.get(`${this.baseUrl}/getProfile?tutor_id=${id}&enquiry_id=${iid}`))
    )
  }


}
export default new Shortlistedtutors();
